module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Regular.woff
// module id = 63
// module chunks = 8